import { useMemo } from 'react';
import {
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  PartnerSpecificFormData,
  usePartnerSpecificModalConfigMap,
} from './PartnerSpecificFormConfig';
import OptimusButton from '../../../../common/library/Button/Button';
import { TestIds } from '../../../../assets/testIds';
import { PartnerName } from '../../../../common/constants';

interface PartnerNoFormComponentProps {
  partnerName: string;
  partnerCode?: string;
  onSubmitForm: (data: PartnerSpecificFormData | null) => void;
  loading: boolean;
  manufacturerName?: PartnerName;
}

export default function PartnerNoFormComponent({
  partnerName,
  partnerCode,
  onSubmitForm,
  loading,
  manufacturerName,
}: PartnerNoFormComponentProps) {
  const { t } = useTranslation();
  const partnerSpecificModalConfigMap = usePartnerSpecificModalConfigMap();
  const partnerConfig = useMemo(() => {
    if (!partnerCode || !(partnerCode in partnerSpecificModalConfigMap)) {
      return undefined; // or some default config
    }
    return partnerSpecificModalConfigMap[partnerCode];
  }, [partnerCode, partnerSpecificModalConfigMap]);

  return (
    <Box display="flex" flexDirection="column" gap={3} mt={2}>
      <Typography variant="body1"> {partnerConfig?.submitDescription} </Typography>
      <OptimusButton
        size={'m'}
        buttonText={loading ?
          <CircularProgress color="inherit" size={24} /> :
          <Typography component='span' data-testid={TestIds.rewardsPage.noFormModal.submitBtn} sx={{ fontWeight: 600 }}>
            {manufacturerName ?
              `${t('button.enrollAndContinueWith')} ${manufacturerName}` :
              t('button.submit')}
          </Typography>}
        onClick={() => onSubmitForm(null)}
        data-testid={TestIds.onboarding.homedepotShowAgainLnk}
      />
    </Box>
  );
}
